export default "__VITE_ASSET__Cp7Li5hl__"